import React, {useState} from "react";
import {Col, Nav, Row} from "react-bootstrap";
import List from "./List";
import {clsx} from "clsx";
import ArrowActive from "../Shared/icons/Arrow";
import ArrowWhite from "../Shared/icons/ArrowWhite";

function JobOpportunityTabsDesktop({currentStatus, statusText, tabs, buttonText, scrollToForm}) {
    const [activeTab, setActiveTab] = useState(null);

    const handleScroll = (e, id) => {
        e.preventDefault();
        setActiveTab(id); // Update the active tab state

        const element = document.getElementById(id);
        if (element) {
            const yOffset = -275;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({
                top: y,
                behavior: 'smooth',
            });
        }
    };

    return (
        <>
            <Row className="row">
                <Col className="col-12 col-xl-4 col-mb" style={{position: 'sticky', top: 150, marginBottom: 'auto'}}>
                    {currentStatus &&
                        <List status={currentStatus}
                              text={statusText}
                        />
                    }

                    <Nav variant="pills" className="flex-column">
                        <div className="card card__links">
                            <div className="card-body pt-2">
                                {tabs.map((item) => (
                                    <div key={item.name} className="vacature-detail__list">
                                        <Nav.Item>
                                            <a href={`#${item.name}`}
                                               onClick={(e) => handleScroll(e, item.name)}
                                               className={clsx("vacature-detail__tab my-6 d-flex", {
                                                   "active": activeTab === item.name // Conditionally add "active" class
                                               })}
                                            >

                                                <h3 className="card-title mb-0">{item.name}</h3>
                                                <div className="card-icon">
                                                    <ArrowActive/>
                                                </div>
                                            </a>
                                        </Nav.Item>
                                    </div>
                                ))}

                                {buttonText && currentStatus !== "closed" &&
                                    <div className="mt-8">
                                        <a href="#" onClick={scrollToForm}
                                           className="w-auto btn btn-success justify-content-between d-inline-flex">
                                            <span className="">{buttonText}</span>
                                            <ArrowWhite/>
                                        </a>
                                    </div>
                                }
                            </div>
                        </div>
                    </Nav>
                </Col>
                <Col className="col-12 col-xl-8 col-mb">
                    {tabs.map((item) => (
                        <div id={item.name} key={item.name} className="pb-4">
                            <div className="card card__links">
                                <div className="card-body">
                                    <h3 className="card-title">{item.name}</h3>
                                    <div className="card-ul-arrow card-ul-arrow--nopadding"
                                         dangerouslySetInnerHTML={{__html: item.content}}>

                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </Col>
            </Row>
        </>
    );
}

export default JobOpportunityTabsDesktop;